"use strict";

import querystring from "querystring";
import tokenProvider from "./token";
import hostProvider from "./host";

function call(method, endpoint, ...options) {
	
	let host = "";
	let data = null;
	let timeout = null;
	let callback = function(error, response){};
	
	for (let option of options) {
		if(!option){
			continue;
		}
		if(option.constructor == Object){
			data = option;
		}
		else if(option.constructor == Function){
			callback = option;
		}
		else if(option.constructor == String){
			host = "/" + option;
		}
		else if(option.constructor == Number){
			timeout = option;
		}
	}
	
	let xhr = new XMLHttpRequest();
	
	if (timeout)
		xhr.timeout = timeout;
		
	async function send(host) {
		
		//host = "https://"+host+"/api/";
		host = "/api/";
		
		if (method.toUpperCase() == 'GET'){
			xhr.open(method, host + endpoint + (data ? "?" + querystring.stringify(data) : ""));
		}
		else {
			xhr.open(method, host + endpoint);
		}
		
		xhr.setRequestHeader("Content-type", "application/json");
		
		const token = await tokenProvider.get();
		
		if (token){
			xhr.setRequestHeader("token", token);
		}
		
		if (method.toUpperCase() == 'GET'){
			xhr.send();
		}
		else{
			xhr.send( data ? JSON.stringify(data) :  null );
		}
	}
	
	async function sendByHost() {
		if (host) {
			send(host);
		}
		else {
			host = await hostProvider.get();
			if (host) send(host);
			else send(window.location.host);
		}
	}
	
	sendByHost();
	
	return new Promise((resolve, reject) => {
		
		xhr.onload = function(){

			if (xhr.responseText) {
				let response = JSON.parse(xhr.responseText);

				if (response.type == 'ErrorResponse') {
					callback(response);
					reject(response);
				}
				else {
					callback(null, response);
					resolve(response);
				}
			}
			else if (xhr.status != 200) {
				let response = {
					type: 'ErrorResponse',
					id: 'UNKNOWN_ERROR',
					message: xhr.statusText + ": " + xhr.responseText,
					group: 'UNKNOWN_ERROR',
					code: xhr.status
				};
				
				callback(response);
				reject(response);
			}
		};
		
		xhr.ontimeout = function() {
			let response = {
				type: 'ErrorResponse',
				id: 'TIMEOUT_ERROR',
				message: "Timeout: " + xhr.timeout + " ms",
				group: 'UNKNOWN_ERROR',
				code: xhr.status
			};
			
			callback(response);
			reject(response);
		};
		
		xhr.onerror = function() {
			let response = {
				type: 'ErrorResponse',
				id: 'UNKNOWN_ERROR',
				message: "Something wrong",
				group: 'UNKNOWN_ERROR',
				code: null
			};
			
			callback(response);
			reject(response);
		}
	});
}

function get(...args){
	args.unshift('get');
	return call(...args);
}

function post(...args){
	args.unshift('post');
	return call(...args);
}

function put(...args){
	args.unshift('put');
	return call(...args);
}

function delete_(...args){
	args.unshift('delete');
	return call(...args);
}

export default {
	get: get,
	post: post,
	put: put,
	delete: delete_
};


// WEBPACK FOOTER //
// ./~/vwa/api.js